export const TableColumns = [
    { text: "Biển số xe", icon: <></> },
    { text: "Ngày giao hàng", icon: <></> },
    { text: "Đơn hàng sản phẩm", icon: <></> },
];